import { SortingState } from '@hub/libs/bearing-hub.helper';

type SortableValue = number | string | undefined;

export const compareBearingTableValues = (
  valueA: SortableValue,
  valueB: SortableValue,
  sortingState: SortingState
): number => {
  if (valueA === valueB) {
    return 0;
  }
  if (valueA === -1) {
    return 1;
  }
  if (valueB === -1) {
    return -1;
  }

  if (typeof valueA === 'string' && typeof valueB === 'string') {
    return sortingState === SortingState.Descending ? valueB.localeCompare(valueA) : valueA.localeCompare(valueB);
  }

  if (typeof valueA === 'number' && typeof valueB === 'number') {
    return sortingState === SortingState.Descending ? valueB - valueA : valueA - valueB;
  }

  return 0;
};
